export class Identifiable {
  id: number;
}
